import { setToken } from 'lib/common'
import { globalConst as native, mutationNames } from 'lib/const'
import { isEmptyObject, margeMutations } from 'lib/utils'
import { applyClientMiddleware } from 'src/main'
import api from 'api/api'
import { createModule } from '../../plugins/vuex-request/VuexModule'

const state = {
  loading: false,
  token: null,
  expiresIn: 0,
  doLoadJsConfig: {}
}

const getters = {}
const actions = {
  [native.doLoadJsConfig] ({state}, refs) {
    if (isEmptyObject(state.doLoadJsConfig)) {
      return applyClientMiddleware(api.doLoadJsConfig, refs)
    }
  },
}
let mutations = {
  doAlreadyBind (state, credential) {
    console.log('设置token', credential)
    state.token = credential.token
    state.expiresIn = credential.expireTime - new Date().getTime()
  },
  [mutationNames.doLoadJsConfig_success] (state, {data}) {
    state.wechatConfig = {
      beta: true,
      ...data
    }
    console.log('wechatCOnfig==>', state.wechatConfig)
    wx.config(state.wechatConfig)
    wx.ready(() => {
      console.log('wx ready')
    })
    wx.error((error) => {
      console.error('wx error', error)
    })
  },
}
mutations = Object.assign(margeMutations(actions), mutations)
export default createModule(state, getters, actions, mutations, false)
